// Port of api/fuel/app/classes/controller/api/monty/artists/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT artist_id, artist_name FROM artist WHERE LOWER(artist_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND artist_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].artist_id] = { id: rows[i].artist_id, name: rows[i].artist_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
